import React, { FC } from 'react';
import {
  Button,
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import { JSONForm } from '../../../../components/json-form/JSONForm';
import { useTranslation } from '../../../../translations';

interface WebhookModalProps {
  readonly types: string[];
  readonly open: boolean;
  readonly onClose: (cancelled: boolean) => void;
}

export const WebhookModal: FC<WebhookModalProps> = ({ open, types, onClose }) => {
  const { ts } = useTranslation();
  return (
    <Modal isOpen={open}>
      <JSONForm
        id="webhook-form"
        method="post"
        onSuccess={() => {
          onClose(false);
        }}
        path="/api/webhooks"
      >
        <ModalHeader>{ts('webhook.create')}</ModalHeader>
        <ModalBody>
          <FormGroup row>
            <Label for="name" md={4} sm={12}>
              {ts('name')}
            </Label>
            <Col md={8} sm={12}>
              <Input name="name" />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label for="url" md={4} sm={12}>
              {ts('url')}
            </Label>
            <Col md={8} sm={12}>
              <Input name="url" type="url" />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label for="url" md={4} sm={12}>
              {ts('events')}
            </Label>
            <Col md={8} sm={12}>
              <Input multiple name="events" type="select">
                {types.map((t) => (
                  <option key={t} value={t}>
                    {t}
                  </option>
                ))}
              </Input>
            </Col>
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" type="submit">
            {ts('common.create')}
          </Button>
          <Button
            color="secondary"
            onClick={() => {
              onClose(true);
            }}
          >
            {ts('common.cancel')}
          </Button>
        </ModalFooter>
      </JSONForm>
    </Modal>
  );
};
